var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "align-center": "", "justify-center": "", role: "region" } },
    [
      _c(
        "v-flex",
        { attrs: { xs11: "", sm11: "", md11: "", md4: "", lg4: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "pa-4",
              attrs: {
                color: "secondary",
                elevation: "2",
                role: "form",
                "aria-labelledby": "reset-password-heading",
              },
            },
            [
              _c(
                "v-app-bar",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "text-body-2",
                      attrs: { id: "reset-password-heading" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("components.resetPass.title")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        "aria-label": _vm.$t(
                                          "components.resetPass.buttons.signin"
                                        ),
                                        small: "",
                                        color: "accent",
                                        to: _vm.toSignInLink,
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.resetPass.buttons.signin"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("components.resetPass.buttons.signin"))
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { attrs: { fluid: "", "grid-list-md": "" } },
                [
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    staticClass: "mb-3",
                    attrs: {
                      color: "accent",
                      indeterminate: "",
                      role: "status",
                      "aria-label": "Loading",
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasErrors
                    ? _c(
                        "div",
                        {
                          staticClass: "mb-4",
                          attrs: { role: "alert", "aria-live": "assertive" },
                        },
                        _vm._l(
                          _vm.filteredErrors,
                          function (errorsGroup, errorsGroupIndex) {
                            return _c(
                              "div",
                              { key: errorsGroupIndex },
                              _vm._l(errorsGroup, function (error) {
                                return _c(
                                  "v-alert",
                                  {
                                    key: error.id,
                                    attrs: {
                                      type: error.type,
                                      icon: error.icon,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(error.msg) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "aria-describedby": "form-description" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.validate($event)
                        },
                      },
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:6|max:255",
                                    expression: "'required|min:6|max:255'",
                                  },
                                ],
                                attrs: {
                                  "prepend-icon": "fal fa-envelope",
                                  color: "accent",
                                  "data-vv-as": "email or username",
                                  "data-vv-name": "email",
                                  "error-messages": _vm.errors.collect("email"),
                                  label: _vm.$t(
                                    "components.resetPass.form.userOrEmail"
                                  ),
                                  name: "email",
                                  type: "text",
                                  autocomplete: "username",
                                  "aria-required": "true",
                                  required: "",
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": _vm.$t(
                                  "components.resetPass.buttons.reset"
                                ),
                                color: "accent",
                                type: "submit",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("components.resetPass.buttons.reset")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }